<template>
  <div style="flex: 1; padding: 20px">
    <el-table v-loading="loading" :data="triggers">
      <el-table-column
        prop="macAddress"
        :label="$t('trigger.macAddress')"
      ></el-table-column>
      <el-table-column :label="$t('trigger.status')">
        <template slot-scope="scope_e">
          <span
            v-if="
              scope_e.row.status &&
              scope_e.row.status.shadow &&
              scope_e.row.status.shadow.reported
            "
          >
            <el-tooltip
              style="width: 300px"
              :content="
                'last disconnect reason: ' +
                scope_e.row.status.shadow.reported.disconnectReason
              "
              placement="top"
            >
              <span>{{
                $t(`common.${scope_e.row.status.shadow.reported.eventType}`)
              }}</span>
            </el-tooltip>
            <br />
            <span>{{
              toDisplayDate(scope_e.row.status.shadow.reported.timestamp)
            }}</span>
          </span>
          <span v-else> N/A </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import preferences from "../util/preferences";
import dayjs from "dayjs";
export default {
  name: "Senseways",
  data() {
    return {
      results: {},
      formLoading: false,
    };
  },
  created() {
    this.getTriggers().then(() => {
    });
  },
  computed: {
    ...mapState("trigger", ["triggers", "loading"]),
  },
  methods: {
    toDisplayDate(timestamp) {
      return dayjs(timestamp).format(preferences().localization.dateFormat);
    },
  },
};
</script>
<style>
.el-tooltip__popper {
  max-width: 320px;
}
</style>
<style scoped>
.el-dialog {
  margin-top: 15vh !important;
  width: 40% !important;
}
p {
  margin-left: 30px;
}
.el-form-item__content label.country-selector__label {
  line-height: normal;
}

.el-form-item__content label.input-tel__label {
  line-height: normal;
}
.vue-phone-number-input .select-country-container {
  min-width: 100px !important;
  max-width: 100px !important;
}
.el-tooltip__popper {
  max-width: 500px !important;
  width: 400px !important;
}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  flex-basis: 80%;
  display: flex;
}
.component {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}
.component-container {
  margin: 0 10px 20px 10px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  min-width: 300px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  flex: 1 0 48%;
}
</style>